<template>
  <div class="col-12">
    <div
      v-for="(price, index) in getOfferPrices"
      :key="index"
      class="pointer white-bg col-12 p1"
      @click="handleClick(price)"
    >
      <div class="col-12 flex flex-wrap">
        <div class="col-11 lg-col-11 md-col-11 sm-col-9 flex flex-wrap">
          <div class="flex flex-wrap items-center col-12">
            <div class="flex col-12">
              <span class="h5 bold sm-hide xs-hide">
                {{ price.label.toLowerCase() }}</span>
              <span class="h6 bold lg-hide md-hide">
                {{ price.label.toLowerCase() }}</span>
            </div>
            <div class="flex col-12">
              <span v-if="price.conditions" class="h5 col-12 sm-hide xs-hide">{{
                price.conditions.title
              }}</span>
              <span v-if="price.conditions" class="h6 col-12 lg-hide md-hide">{{
                price.conditions.title
              }}</span>
            </div>
          </div>
          <div
            class="
              flex
              col-12
              flex
              items-center
              h6
            "
          >
            <span :class="['bold', { crossed: computePromo(price).canShow }]">
              <span v-if="price.price > 0">
                {{ computeTariffPrice(price) }}€
                <span v-if="isRecurring" class="h5">/ mois</span>
              </span>
              <span v-else> OFFERT </span>
            </span>
            <span v-if="computePromo(price).canShow" class="h5 bold">{{
              computePromo(price).price
            }} €</span>
          </div>
        </div>
        <div
          v-if="!isSelected(price) || !showQuantityChanger"
          class="
            col-1
            lg-col-1
            md-col-1
            sm-col-3
            flex
            justify-center
            items-center
            pl1
          "
        >
          <span
            :class="[
              'custom-radio flex center',
              { 'selected-item': isSelected(price) },
            ]"
          ></span>
        </div>
        <div
          v-else
          class="flex col-1 lg-col-1 md-col-1 sm-col-3 h6n bold items-center justify-center pl1"
        >
          <i
            v-if="quantity > 1"
            style="top: 2px"
            class="icon icon-minus pointer"
            @click="handleQuantity(-1)"
          ></i>
          <span class="mx1">{{ quantity }}</span>
          <i
            style="top: 2px"
            class="icon icon-add-more-icon pointer"
            @click="handleQuantity(1)"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computePromo } from '@/utils/logics';

export default {
  props: {
    contact: {
      type: Object,
      default: null
    },
    offer: {
      type: Object,
      default: null
    }
  },
  data () {
    return { siteInfo: this.$store.state.siteInfo };
  },
  computed: {
    sessions () {
      return this.$store.state.sessions?.items;
    },
    showQuantityChanger () {
      // const disabled_features = this.siteInfo.tda_settings.disabled_features || [];
      // return !disabled_features.includes('participant-quantity-changer');
      return false;
    },
    getOfferPrices () {
      if (!this.offer || !this.offer.detail || !this.offer.detail.prices) {
        return [];
      }
      return [...this.offer.detail.prices].sort((a, b) => a.price - b.price);
    },
    selectedTariff () {
      const { cartItem } = this.$store.state;
      const participant = cartItem.participants.find(
        p => p.uuid === this.contact.uuid
      );
      return cartItem && participant && participant.tariff
        ? participant.tariff
        : {};
    },
    quantity () {
      const { cartItem } = this.$store.state;
      const participant = cartItem.participants.find(
        p => p.uuid === this.contact.uuid
      );
      return cartItem && participant && participant.quantity
        ? participant.quantity
        : 0;
    },
    isRecurring () {
      return this.offer.detail.recurring;
    }
  },
  methods: {
    computePromo,
    computeTariffPrice (price) {
      return parseFloat(price.price / 100).toFixed(2);
    },
    isSelected (price) {
      const { tariffCode } = this.selectedTariff;
      return tariffCode === price.tariffCode;
    },
    handleClick (tariff) {
      if (!this.isSelected(tariff)) {
        this.$store.commit('resetParticipantQuantity', { participant: this.contact });
        this.$store.commit('addCartItemParticipantTariff', {
          participant: this.contact,
          tariff: tariff
        });

        this.$store.commit('setCurrentParticipant', { ...this.contact, tariff: tariff });

        const { cartItem } = this.$store.state;
        const session = this.sessions[0];

        cartItem.details.activities = session.activities;
        cartItem.session = {
          name: session.nomActivite,
          code: session.codeCreneau,
          start_time: session.timestampDebutCreneau,
          end_time: session.timestampFinCreneau,
          last_time: session.timestampDernierCreneau
        };
        this.$store.commit('setCartItem', { ...cartItem });
      }
    },
    handleQuantity (quantity) {
      if (this.quantity + quantity >= 0) {
        this.$store.commit('changeParticipantQuantity', {
          participant: this.contact,
          quantity: quantity
        });
      }
    }
  }
};
</script>
